import React from 'react';
import { scrollToOffer } from '../utils/scroll';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: '30 Storie di Yoga per Bambini',
    desc: 'Avventure guidate che trasformano le posizioni yoga in storie divertenti e coinvolgenti.',
    value: '19,99'
  }, {
    num: 2,
    title: '50 Carte di Respirazione per Bambini',
    desc: 'Carte stampabili con esercizi di respirazione semplici e visuali.',
    value: '14,99'
  }, {
    num: 3,
    title: '21 Routine di Yoga per Bambini',
    desc: 'Un programma di 21 giorni con attività di yoga e mindfulness.',
    value: '17,99'
  }, {
    num: 4,
    title: 'Attività Creative per Mindfulness',
    desc: 'Attività artistiche e creative per aiutare i bambini a esprimere emozioni e sviluppare calma interiore.',
    value: '12,99'
  }];
  return <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-20">
      <div className="max-w-4xl mx-auto" data-id="element-21">
        <div className="text-center mb-12" data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-23">
            E non è tutto.
          </h2>
          <p className="text-xl md:text-2xl text-amber-400 font-medium" data-id="element-24">
            Se accedi oggi riceverai anche 4 bonus speciali.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-25">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-gray-800 rounded-2xl p-6 border border-gray-700 relative overflow-hidden" data-id="element-26">
              <div className="absolute top-0 right-0 bg-green-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-27">
                GRATIS per oggi
              </div>
              <div className="flex items-center mb-4" data-id="element-28">
                <Gift className="w-8 h-8 text-amber-400 mr-3" data-id="element-29" />
                <h3 className="text-xl font-bold text-white" data-id="element-30">
                  BONUS {bonus.num}
                </h3>
              </div>
              <h4 className="text-lg font-semibold text-blue-300 mb-2" data-id="element-31">
                {bonus.title}
              </h4>
              <p className="text-gray-300 mb-6" data-id="element-32">{bonus.desc}</p>

              <div className="mt-auto pt-4 border-t border-gray-700 flex items-center justify-between" data-id="element-33">
                <span className="text-gray-500 line-through text-lg" data-id="element-34">
                  {bonus.value} €
                </span>
                <span className="text-green-400 font-bold text-xl" data-id="element-35">GRATIS</span>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-36">
          <p className="text-xl text-gray-300 mb-8 font-medium" data-id="element-37">
            In totale riceverai 9 risorse complete per yoga e mindfulness per
            bambini.
          </p>
          <button onClick={scrollToOffer} className="bg-amber-500 hover:bg-amber-600 text-gray-900 font-extrabold text-xl py-5 px-10 rounded-full shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 w-full md:w-auto" data-id="element-38">
            VOGLIO TUTTI I BONUS GRATIS
          </button>
        </div>
      </div>
    </section>;
}